import React from 'react';
import './HorizontalRule.css';

const HorizontalRule = () => <hr className="horizontal-rule" />;

export default HorizontalRule;



// WEBPACK FOOTER //
// ./src/components/HorizontalRule/HorizontalRule.jsx